import { Injectable } from "@angular/core";
import { DropdownSettingsFactory } from "../dropdown/dropdown-settings.factory";
import { DropdownItemFactory } from "../dropdown/dropdown-item.factory";
import { LocalStorage } from "../../wrappers/LocalStorage";
import { CommonHelper } from "../../helpers/CommonHelper";
import { FiltersFactory } from "../filters.factory";
import { ConsultantService } from "../../../services/consultant.service";
import { OptionsConsultants } from "../../enums/consultants/OptionsConsultant";
import { UserService } from "../../../services/user.service";
import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { IndustriesService } from '../../../services/industries.service';

@Injectable()
export class ConsultantFilterFactory extends FiltersFactory{
    constructor(private localStorage: LocalStorage,
        private commonHelper: CommonHelper,
        private optionsConsultant: OptionsConsultants,
        private dropdownItemFactory: DropdownItemFactory,
        private dropdownSettingFactory: DropdownSettingsFactory,
        private userService: UserService,
        private consultantService: ConsultantService,
        private excellenceCentersService: ExcellenceCentersService,
        private industriesService: IndustriesService) { super() }


    async build(filters, localStorageFilterKey = 'consultants') {

        if(filters.responsible){
            filters.responsible.list = this.dropdownItemFactory.build({source:await this.userService.getAllUsersAsResponsibles()});
            filters.responsible.options = this.dropdownSettingFactory.build({text:"Gestor"});
        }

        filters.division.list = this.optionsConsultant.division;
        filters.active.list = this.optionsConsultant.status;
        filters.kind.list = this.optionsConsultant.model;

        if (filters.year)
            filters.year.list = this.commonHelper.listLastYears();

        if(filters.yearend)
            filters.yearend.list = this.commonHelper.listLastYears();

        if (filters.month)
            filters.month.list = this.commonHelper.listAllMonths();

        if (filters.monthend)
            filters.monthend.list = this.commonHelper.listAllMonths();

        if (filters.additivePending) {
            filters.additivePending.list = this.optionsConsultant.additivePending;
            filters.additivePending.options = this.dropdownSettingFactory.build({ text: 'Status aditivo','singleSelection':true });
        }

        filters.division.options = this.dropdownSettingFactory.build({ text: 'Divisões' });
        filters.active.options = this.dropdownSettingFactory.build({ text: 'Status','singleSelection':true });
        filters.kind.options = this.dropdownSettingFactory.build({ text: 'Modelo' });

        if(filters.industry) {
            filters.industry.list = this.dropdownItemFactory.build({ source: await this.industriesService.getAll()});
            filters.industry.options = this.dropdownSettingFactory.build({ text: 'Setor',enableCheckAll:true, selectAllText:'Marcar todos os setores' });
        }

        const typeCenters = await this.excellenceCentersService.getAll();
        if (filters.excellenceCenter) {

            filters.excellenceCenter.list = this.dropdownItemFactory.build({ source: typeCenters.filter(ec => ec.type == 1)});
            filters.excellenceCenter.options = this.dropdownSettingFactory.build({ text: 'Centro de Excelência',enableCheckAll:true, selectAllText:'Marcar todos os centros de excelência' });
        }
        if (filters.supportCenter) {
            filters.supportCenter.list = this.dropdownItemFactory.build({ source: typeCenters.filter(ec => ec.type == 2)});
            filters.supportCenter.options = this.dropdownSettingFactory.build({ text: 'Área de suporte',enableCheckAll:true, selectAllText:'Marcar todas as áreas de suporte'});
        }

        const filtersStored = this.localStorage.retrieve(localStorageFilterKey);
        return filtersStored ? this.loadStored(filters, filtersStored) : filters;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/consultants/filters.factory.ts